import React, {Component} from 'react';
import { Button, ContentSwitcher, Switch, Tile } from 'carbon-components-react';
import * as midi from '../js/rpl_midi.js';

class LoadPresetButton extends React.Component {
	constructor(props) {
		super(props);

		this.progNum = props.progNum;
		this.textLabel = props.textLabel;


		this.handleClick = this.handleClick.bind(this);
	}

	render() {
		return (
		  <Tile>
			<Button kind="secondary" size="small" onClick={this.handleClick}>{this.textLabel}</Button>
		  </Tile>
		);
	}

	handleClick(ev) {
		midi.sendProgramChange(this.progNum);
	}
}

class LoadPresetGrid extends React.Component {
	constructor(props) {
		super(props);

		this.numProgs = props.numProgs;
		this.liveProg = props.liveProg;
	}

	createGrid() {
		var grid = [];

		var progNum = 0;

		var numRows = Math.ceil(this.numProgs / 16);

		// rows
		var rows = [];
		for (var i = 0; i < numRows; i++) {
		  // columns
		  var cols = [];
		  for (var j = 0; j < 16 && progNum < this.numProgs; j++) {
			var label = (progNum + 1 == this.liveProg) ? "Live" : progNum + 1;
			cols.push(
			  <div className="bx--col-sm-1 bx--col-md-1 bx--col-lg-1">
				<LoadPresetButton progNum={progNum} textLabel={label}/>
			  </div>
			);
  
			progNum += 1;
		  }

		  rows.push(<div className="bx--row editor-page__tab-preset">{cols}</div>)
		}

		grid.push(rows);

		return grid;
	}

	render() {
		return (
			  <div>
				{this.createGrid()}
			  </div>
		);
	}
}

class SavePresetButton extends React.Component {
	constructor(props) {
		super(props);

		this.progNum = props.progNum;
		this.textLabel = props.textLabel;

		this.handleClick = this.handleClick.bind(this);
	}

	render() {
		  return (
			<Tile>
			  <Button kind="danger" size="small" onClick={this.handleClick}>{this.textLabel}</Button>
			</Tile>
		  );
	}

	handleClick(ev) {
		midi.saveProgram(this.progNum);
	}
}

class SavePresetGrid extends React.Component {
	constructor(props) {
		super(props);

		this.numProgs = props.numProgs;
		this.liveProg = props.liveProg;
	}

	createGrid() {
		var grid = [];

		var progNum = 0;

		var numRows = Math.ceil(this.numProgs / 16);

		// rows
		var rows = [];
		for (var i = 0; i < numRows; i++) {
		  // columns
		  var cols = [];
		  for (var j = 0; j < 16 && progNum < this.numProgs; j++) {
			if (progNum + 1 != this.liveProg) {
			  cols.push(
			    <div className="bx--col-sm-1 bx--col-md-1 bx--col-lg-1">
				  <SavePresetButton progNum={progNum} textLabel={progNum + 1}/>
			    </div>
			  );
			}
  
			progNum += 1;
		  }

		  rows.push(<div className="bx--row editor-page__tab-preset">{cols}</div>)
		}

		grid.push(rows);

		return grid;
	}

	render() {
		return (
			  <div>
				{this.createGrid()}
			  </div>
		);
	}
}

/*
 * Grid to load/save presets.
 *
 * numProgs - number of available presets (including "live") (default: 128).
 * liveProg - program number for "live" knob settings (1-based, optional).
 */
class PresetGrid extends React.Component {

	constructor(props) {
		super(props);

		this.numProgs = props.numProgs || 128;
		this.liveProg = props.liveProg || -1;

		this.handleChange = this.handleChange.bind(this);

		this.state = {
			activeSwitch: 0
		}
	}

	createActiveSwitch() {
		if (this.state.activeSwitch == 0) {
			return(
	  		  <LoadPresetGrid numProgs={this.numProgs} liveProg={this.liveProg}/>
			);
		} else {
			return(
	  		  <SavePresetGrid numProgs={this.numProgs} liveProg={this.liveProg}/>
			);
		}
	}

	render() {
		return (
	  		  <div className="bx--grid bx--grid--no-gutter bx--grid--full-width">
	  			<div className="bx--row editor-page__tab-preset">
	  			  <div className="bx--col-sm-2 bx--col-md-4 bx--col-lg-8">
	  	  			<ContentSwitcher onChange={this.handleChange}>
			 		  <Switch name={'loadPreset'} text="Load"/>
					  <Switch name={'savePreset'} text="Save"/>
					</ContentSwitcher>
	  			  </div>
	  			</div>
				<div>
			      {this.createActiveSwitch()}
				</div>
	  		  </div>
		);
	}

	handleChange(props) {
		this.setState({activeSwitch : props.index});
	}
}

export default PresetGrid;
